import { isEmpty } from 'ramda';
import React from 'react';
import { Col, Row } from 'reactstrap';

class MultiSelectFilter extends React.Component {
  onChange = (value) => {
    this.props.onInputChange(value);
  }

  onItemClick = (obj) => {
    this.props.clientIdsSelectedEvent(this.props, obj);
  }

  renderOptions() {
    const { focusToFirstPosition, dataObj, clientIdsSelected } = this.props;
    const options = (dataObj || []).map((obj, index) => {
      const checkIndex = clientIdsSelected ? clientIdsSelected.indexOf(obj.id) : -1;
      return (
        <div
          key={index}
          value={obj.id}
          className={'list-item display-flex ' + (checkIndex !== -1 ? 'selectedCheckbox ' : 'unSelectCheckbox')}>
          <span
            className="width-100"
            tabIndex={0}
            onClick={() => this.onItemClick(obj)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.onItemClick(obj);
              }
              if (focusToFirstPosition && e.key === 'Tab' && !e.shiftKey && dataObj.length - 1 === index) {
                focusToFirstPosition(e);
              }
            }}
            role={'checkbox'}
            aria-label={obj.name}
            aria-checked={checkIndex !== -1}>
            <i className={'checkBox far ' + (checkIndex !== -1 ? 'fa-check-square' : 'fa-square')}></i>
            <span className="checkBox-title">{obj.name}</span>
          </span>
        </div>
      );
    });
    return options;
  }

  renderNoResultsAlert() {
    const msg = (<div
      role="alert"
      className="fontSm-15 bold-font mTop-5"
      aria-label={`No results for ${this.props.name}. Please adjust your search and try again.`}>
      No Results. Please adjust your search and try again.
    </div>);
    return msg;
  }

  render() {
    const { block, placeholder, maxHeight, isEmbedMenu } = this.props;
    const options = this.renderOptions();
    const isLoaded = !isEmpty(this.props.originalData);
    return (
      <Row className="multiselect v-middle-align" role={isEmbedMenu ? "menuitem" : "none"}>
        {this.props.searchBar ? (
          <Col className={'input-left relative ' + (block ? 'col-xs-12' : 'col-sm-12')}>
            <input
              aria-label="search text"
              className="input multi-select-search"
              placeholder={placeholder}
              onChange={(evt) => this.onChange(evt.target.value)}
              value={this.props.value}
            />
            <span className="search-icon">
              <i className="fa fa-search"></i>
            </span>
          </Col>
        ) : void 0}
        <div
          hidden={this.props.noResult && options.length === 0 && isLoaded}
          className="searchBoxList"
          style={{ maxHeight: maxHeight, paddingTop: '10px' }}
          {...isEmbedMenu ? {} : {
            role: 'group',
            'aria-label': this.props.name,
          }}>
          {options}
        </div>
        {this.props.noResult && options.length === 0 && isLoaded ? this.renderNoResultsAlert() : void 0}
      </Row>
    );
  }
}

export default MultiSelectFilter;
